<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<div class="titlePage" id="tit01">
<h2 class="titlePageTitle"><span class="bold"><a id="page06"></a><a id="page07"></a>Nectar</span></h2>
<p class="titlePageSubtitle"><em class="italic">a novel of temptation</em></p>
<h2 class="titlePageAuthor"><span class="bold"><em class="italic">Lily Prior</em></span></h2>
<p class="colophon"><img alt="logo" src="logo.jpg"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?4089c3fc